import React from 'react';
import { PropTypes } from 'prop-types';

const FreeTextFilter = ({ column: { setFilter, filterValue, preFilteredRows, filterIconId, filterTextFieldId } }) => {
  const [inputValue, setInputValue] = React.useState('');
  const [showFilter, setShowFilter] = React.useState(false);
  const node = React.useRef();

  const handleClickOutside = (e) => {
    if (node === null || node.current === null) {
      return;
    }

    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    setShowFilter(false);
  };

  const keyHit = (e) => {
    if (e.keyCode === 13) {
      setShowFilter(false);
      setFilter({
        filter: [inputValue],
        filterType: 'text'
      });
    }
  };

  React.useEffect(() => {
    setInputValue('');
  }, [preFilteredRows]);

  React.useEffect(() => {
    setInputValue(filterValue != null && filterValue.filter.length > 0 ? filterValue.filter[0] : '');
  }, [filterValue]);

  React.useEffect(() => {
    if (showFilter) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilter]);

  return (
    <div ref={ node } className={ `clickover clickover-bottom filter ${ showFilter ? 'active' : '' }` }>
      <button
        id={ filterIconId }
        type="button"
        onClick={ () => setShowFilter(!showFilter) }
        className={ `btn btn-link filter-menu ${ filterValue != null && filterValue.filter.length > 0 && filterValue.filter[0] !== '' ? 'filter-active' : '' }` }
      >
        ☰
      </button>
      <div className="clickover-container">
        <div className="card card-primary">
          <div className="card-body">
            <div className="columns">
              <div className="col-12">
                <input
                  id={ filterTextFieldId }
                  type="text"
                  value={ inputValue }
                  onChange={ (e) => { setInputValue(e.target.value); } }
                  onKeyUp={ (e) => { keyHit(e); } }
                />
              </div>
              <div className="col-6">
                <button
                  id="search-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={ () => {
                    setShowFilter(false);
                    setFilter({ filter: [inputValue.trim()], filterType: 'text' });
                  } }
                ><span className="icon icon-search" /> Filter</button>
              </div>
              <div className="col-6">
                <button
                  id="clear-btn"
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={ inputValue === '' }
                  onClick={ () => {
                    setShowFilter(false);
                    setInputValue('');
                    setFilter({
                      filter: [],
                      filterType: 'text'
                    });
                  } }
                ><span className="icon icon-cross" /> Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FreeTextFilter.propTypes = {
  column: PropTypes.shape().isRequired,
};

FreeTextFilter.defaultProps = {
};

export default FreeTextFilter;
